import * as React from 'react';
import { ILinkedRoute } from 'src/modules/Routing/types';
import { UserTypes } from 'src/modules/Auth/store/types';
import { validateAuthentication } from 'src/modules/Auth/helpers/validateAuthentication';

interface INavigationLink {
  authorized: boolean;
}

export const useNavLink = (routePath: string, routes: ILinkedRoute[], userType: UserTypes) => {
  const [navLink, setNavLink] = React.useState<INavigationLink>({ authorized: false });
  const linkRoute = React.useMemo(() => {
    return routes.find(route => {
      const path = route.path.find(componentPath => componentPath === routePath);
      return !!path;
    });
  }, []);
  React.useEffect(() => {
    if (linkRoute) {
      const { authorized } = validateAuthentication(userType, linkRoute.policies);
      if (authorized) {
        setNavLink({ authorized })
      }
    }
  }, [linkRoute, userType]);
  return [navLink];
}
